export const baseURL = process.env.REACT_APP_BASE_URL;
export const S3Bucket = process.env.REACT_APP_S3_BUCKET;
export const CDN = process.env.REACT_APP_CDN;
export const exceptThisSymbols = ['e', 'E', '+', '-', '.'];
